import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matching'
})
export class MatchingPipe implements PipeTransform {

  transform(value: any, field: any, returnField: any, array: any[]): any {
    const obj = array.find(item => item[field] === value);
    //console.log('match is here', obj);
    return obj && obj[returnField] ? obj[returnField] : null;
  }
}
